'use client';

import React from 'react';
import { Link } from '@/navigation';
import { UnderlineEffect } from '@/shared/ui/underline-effect';
import inputsIcons from '@/shared/assets/sprites/inputs.sprite.svg';
interface Props {
  link: {
    url: string;
    text: string;
  };
}
export const GoMedcenter: React.FC<Props> = ({
  link
}) => {
  return <Link href={{
    pathname: link.url
  }} target="_blank" data-sentry-element="Link" data-sentry-component="GoMedcenter" data-sentry-source-file="GoMedcenter.tsx">
      <UnderlineEffect className="group flex items-center gap-1" color="bg-additionalBlue" data-sentry-element="UnderlineEffect" data-sentry-source-file="GoMedcenter.tsx">
        <span className="text-sm text-additionalBlue group-hover:text-primary group-active:text-additionalBlue/90">
          {link.text}
        </span>
        <svg className="size-4 rotate-90 fill-additionalBlue text-additionalBlue group-hover:fill-primary group-hover:text-primary group-active:fill-additionalBlue/90 group-active:text-additionalBlue/90" data-sentry-element="svg" data-sentry-source-file="GoMedcenter.tsx">
          <use xlinkHref={`${inputsIcons}#chevron-up`} data-sentry-element="use" data-sentry-source-file="GoMedcenter.tsx"></use>
        </svg>
      </UnderlineEffect>
    </Link>;
};